// extracted by mini-css-extract-plugin
export default {"div":"Reservation_div__Mueug","h2":"Reservation_h2__+Qk5v"};